export const ProgramWeekOverview = {
  bindings: {
    isLoading: '<',
    heading: '<',
    description: '<',
    videoId: '<',
    commentsCount: '<',
    commentsNewCount: '<',
    repliesCount: '<',
    toggleComments: '&',
  },

  template: `
    <section class="container program-week-overview">
      <div class="row d-flex">
        <div class="col-lg pl-lg-0 order-lg-2">
          <video-player-resumable video-id="$ctrl.videoId">
          </video-player-resumable>
        </div>
        <div class="col-lg pr-lg-0 d-flex">
          <div class="program-week-overview-content bg-gray-corner flex-column w-100 justify-content-center text-center">
            <h3>{{ $ctrl.heading }}</h3>
            <p>{{ $ctrl.description | limitTo: 320 }}{{ $ctrl.description.length > 320 ? '...' : '' }}</p>
            <div class="program-week-comments-stats border border-top border-gray-300"
              ng-click="$ctrl.toggleComments()">
              <div class="row py-3" ng-show="$ctrl.isLoading">
                <div class="col-12">
                  <spinner is-loading="true"></spinner>
                </div>
              </div>
              <div class="row" ng-hide="$ctrl.isLoading">
                <div class="col-sm-6 pl-3 pr-0 py-2 theme-btn"
                  ng-hide="$ctrl.commentsCount">
                  <span class="info">
                    <i class="icon icon-comment mr-2"></i>
                    Add a Comment
                  </span>
                </div>
                <div class="col-sm-8 pl-md-5 pr-0 py-2 text-md-left"
                  ng-show="$ctrl.commentsCount > 0">
                  <span class="info text-teal">
                    <i class="icon icon-comment mr-2"></i>
                    {{ $ctrl.commentsCount }}
                    Comments
                  </span>
                </div>
                <div class="col-sm-4 pl-0 pr-2 py-2 theme-btn"
                  ng-show="$ctrl.commentsNewCount > 0 || $ctrl.repliesCount > 0">
                  <span class="info" ng-show="$ctrl.commentsNewCount > 0">
                    {{ $ctrl.commentsNewCount }} New
                  </span>
                  <span class="mx-1 theme-color-secondary" ng-show="$ctrl.commentsNewCount > 0 && $ctrl.repliesCount > 0">|</span>
                  <span class="info" ng-show="$ctrl.repliesCount > 0">
                    {{ $ctrl.repliesCount }} Replies
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>`,
};



// WEBPACK FOOTER //
// ./src/components/Program/ProgramWeekOverview.js